// extracted by mini-css-extract-plugin
export default {"container":"VCGlh","price":"MMaUq","title":"X3sGr","text":"FrFFH"};